/* eslint-disable */
import React, { useEffect, useState, useRef } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import _ from "lodash/fp";
import dayjs from "dayjs";
import {
  SET_MARKS_PDF,
  SET_EXAMINERS_MODERATOR_REPORT_DATA,
} from "../../../common/constants/ActionTypes";
import { format } from "date-fns";
import commonLabels from "../../../common/labels/common_en.json";
import TablePagination from "../../../common/components/TablePagination";
import label from "../../labels/postExaminationProcessObjective_en.json";
import {
  getAdvertisementsList,
  getExamslistByAdvertisementId,
  getSubjectlistByExamId,
  getExaminersAndModeratorReportData,
  getExaminersAndModeratorReportDataPDF,
  getSupervisorlistByExamIdSubjectId,
  getDifferentialReport,
  getAllApprovalExaminersAndModeratorList,
  updateExaminersAndModeratorMarksData,
  requestForLockUnlockStatus,
  getExaminersAndModeratorMarksPDF,
  saveMarksCriteria,
  getAllApprovalMarksCriteria,
  patchMarksCriteria,
  getTotalStudentsByExamIdSubjectId,
  getBarcodeAndRollNo,
  getSubjectBarcodes,
  getExamBarcodes,
} from "../../actions/postExaminationProcessObjectiveActions";
import html2pdf from "html2pdf.js";
import ImportMarkCSV from "./ImportMarkCSV";
import ImportBarcodeCSV from "./ImportBarcodeCSV";
import ExMD_ApprovalEntity from "./ExMD_ApprovalEntity";
import { PrintTablePdf } from "../../../common/components/PrintTablePdf";
import { ExaminerModeratorReportDifferentiatePdf } from "../../../common/components/ExaminerModeratorReportDifferentiatePdf";
import ApprovalMarksCriteriaEntity from "../examReport/ApprovalMarksCriteriaEntity";
import {
  getYearList,
  getAdvertisementlistByYear,
} from "../../../common/actions/commonActions";
import { el, tr } from "date-fns/locale";
import { FiUpload } from "react-icons/fi";

let headerField = [
  {
    id: "1",
    steps: "Step 1",
    name: "Approvals",
  },
  {
    id: "2",
    steps: "Step 2",
    name: "Marks",
  },
  {
    id: "3",
    steps: "Step 3",
    name: "Differential Report",
  },
  {
    id: "4",
    steps: "Step 4",
    name: "Barcode and RollNo List",
  },
  {
    id: "5",
    steps: "Step 5",
    name: "Subject Barcodes",
  },
];

const ExaminersAndModeratorReport = () => {
  const pdfRef = useRef(null);
  let unapprovalEntityHeader = [
    "No.",
    "Action",
    "Status",
    "Updated On",
    "Exam Name",
    "Subject Name",
    "Entity Type",
    "Approval Type",
    "Approver",
    "Comments By Approver",
    "Action",
  ];
  const { register, handleSubmit, errors } = useForm({
    mode: "onChange",
  });
  let {
    examList,
    advertisementList,
    subjectList,
    supervisorListById,
    examinersAndModeratorReportData,
    differentialReportData,
    getAnswerKeyData,
    examinersAndModeratorApprovalList,
    examinersAndModeratorApprovalPageNoCounter,
    allUnapprovalEntityList,
    unapprovalPageNoCounter,
    allMarksPdf,
    markCriteriaApprovalList,
    markCriteriaApprovalPageNoCounter,
    totalStudentCount,
    barcodeAndRollNoList,
    getSubjectCodeRollNo,
    getExamCodeRollNo,
  } = useSelector((state) => state.postExamProcessObjectReducer, shallowEqual);

  let { yearList, allYearList } = useSelector(
    (state) => state.common,
    shallowEqual
  );

  let tableCounter_unapproval = examinersAndModeratorApprovalPageNoCounter + 1;
  let tableCounterMarkCriteria = markCriteriaApprovalPageNoCounter + 1;
  let rowPerPage = 10;
  const length = 50;
  const [selectedAdvertNo, setSelectedAdvertNo] = useState("");
  const [selectedExam, setSelectedExam] = useState("");
  const [selectedSubject, setSelectedSubject] = useState("");
  const [selectedSupervisor, setSelectedSupervisor] = useState("");
  const [supervisor, setSupervisor] = useState("");
  const [selectedYear, setSelectedYear] = useState("");
  const [reloadItem, setReloadItem] = useState(true);
  const [saveButtonFlag, setSaveButtonFlag] = useState(true);
  const [saveReportButtonFlag, setSaveReportButtonFlag] = useState(true);
  const [editedValues, setEditedValues] = useState({});
  const [editMode, setEditMode] = useState(false);
  const [allAnswerValues, setAllAnswerValues] = useState([]);
  const [stepName, setName] = useState("2");
  const [selectedCriteria, setSelectedCriteria] = useState(false);
  let [selectedApprovalEntity, setSelectedApprovalEntity] = useState("");
  let [
    selectedMarksCriteriaApprovalEntity,
    setSelectedMarksCriteriaApprovalEntity,
  ] = useState("");
  let [approvalEntityModal, setApprovalEntityModal] = useState(false);
  let [marksCriteriaApprovalEntityModal, setMarksCriteriaApprovalEntityModal] =
    useState(false);
  let [listCurrentPage, setListCurrentPage] = useState(0);
  let [listMarkCriteriaCurrentPage, setListMarkCriteriaCurrentPage] =
    useState(0);
  const session = JSON.parse(sessionStorage.getItem("session"));
  const date = new Date(); // Your date object here
  const formattedDate = format(date, "MM/dd/yyyy");

  const [showImportBarcode, setShowImportBarcode] = useState(false);
  const [showImportMarks, setShowImportMarks] = useState(false);

  const [barcodeAndRollNo, setBarcodeAndRollNo] = useState([]);
  const [moderatorCriteria, setModeratorCriteria] = useState(
    sessionStorage.getItem("moderatorCriteria") || "false"
  );

  const [chiefModeratorCriteria, setChiefModeratorCriteria] = useState(
    sessionStorage.getItem("chiefModeratorCriteria") || "false"
  );

  const handledUploadList = (type) => {
    if (type === "barcode") {
      setShowImportBarcode(true);
    } else if (type === "marks") {
      setShowImportMarks(true);
    }
  };

  const dispatch = useDispatch();

  useEffect(() => {
    if (
      examinersAndModeratorReportData &&
      examinersAndModeratorReportData.markList &&
      examinersAndModeratorReportData.markList.length == 0
    ) {
      setEditMode(false);
      setSaveButtonFlag(true);
      setSaveReportButtonFlag(true);
    }
  }, [examinersAndModeratorReportData]);

  useEffect(() => {
    if (getAnswerKeyData.answers) {
      setAllAnswerValues(getAnswerKeyData.answers);
    }
  }, [getAnswerKeyData.answers]);

  useEffect(() => {
    window.scrollTo(0, 0);
    dispatch(getYearList());
    if (stepName === "1") {
      dispatch(getAllApprovalExaminersAndModeratorList(0, rowPerPage));
    }

    setReloadItem(!reloadItem);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (stepName === "1") {
      dispatch(
        getAllApprovalExaminersAndModeratorList(listCurrentPage, rowPerPage)
      );
    }
  }, [stepName, listCurrentPage, rowPerPage, dispatch]);

  useEffect(() => { }, [reloadItem]);

  useEffect(() => {
    // setSelectedAdvertNo("");
    onCancelButton();
  }, [stepName]);

  useEffect(() => {
    if (barcodeAndRollNoList && barcodeAndRollNoList.barcodeRollNoListDtos) {
      setBarcodeAndRollNo(barcodeAndRollNoList.barcodeRollNoListDtos);
    }
  }, [barcodeAndRollNoList]);

  const onAdvertisementChange = (ele) => {
    let selectedValue = ele;
    setSelectedAdvertNo(selectedValue);
    examList.length = 0;
    subjectList.length = 0;
    supervisorListById.length = 0;
    examinersAndModeratorReportData.markList &&
      (examinersAndModeratorReportData.markList.length = 0);
    setSelectedExam("");
    setSelectedSubject("");
    setSelectedSupervisor("");
    setSaveButtonFlag(true);
    setSaveReportButtonFlag(true);
    setEditMode(false);
    selectedValue && dispatch(getExamslistByAdvertisementId(selectedValue));
    setReloadItem(!reloadItem);
    dispatch({
      type: SET_MARKS_PDF,
      payload: {},
    });
  };

  const onExamChange = (ele) => {
    let selectedValue = ele;
    subjectList.length = 0;
    supervisorListById.length = 0;
    dispatch({
      type: SET_EXAMINERS_MODERATOR_REPORT_DATA,
      payload: [],
    });
    // examinersAndModeratorReportData.markList && (examinersAndModeratorReportData.markList.length = 0);
    setSelectedExam(selectedValue);
    setSelectedSubject("");
    setSelectedSupervisor("");
    setEditMode(false);
    setSaveButtonFlag(true);
    setSaveReportButtonFlag(true);
    if (stepName === "5") {
      selectedValue && dispatch(getExamBarcodes(selectedValue));
      setSaveButtonFlag(false);
    }
    selectedValue && dispatch(getSubjectlistByExamId(selectedValue));
    setReloadItem(!reloadItem);
    dispatch({
      type: SET_MARKS_PDF,
      payload: {},
    });
  };

  const onSubjectChange = (ele) => {
    let selectedValue = ele;
    setSelectedSubject(selectedValue);
    supervisorListById.length = 0;
    examinersAndModeratorReportData.markList &&
      (examinersAndModeratorReportData.markList.length = 0);
    setSelectedSupervisor("");
    setSaveButtonFlag(true);
    setEditMode(false);
    selectedValue &&
      dispatch(getSupervisorlistByExamIdSubjectId(selectedExam, selectedValue));
    if (stepName === "4") {
      selectedValue &&
        dispatch(getBarcodeAndRollNo(selectedExam, selectedValue));
      setSaveButtonFlag(false);
    }
    if (stepName === "5") {
      selectedValue &&
        dispatch(getSubjectBarcodes(selectedExam, selectedValue));
      setSaveButtonFlag(false);
    }
    //   onSubmit(selectedValue);
    setReloadItem(!reloadItem);
    setEditedValues({});
    dispatch({
      type: SET_MARKS_PDF,
      payload: {},
    });
  };

  const onSupervisorChange = (ele) => {
    let selectedValue = ele;
    setSelectedSupervisor(selectedValue);
    examinersAndModeratorReportData.markList &&
      (examinersAndModeratorReportData.markList.length = 0);
    if (selectedValue == "") {
      setSaveButtonFlag(true);
    } else {
      setSaveButtonFlag(false);
    }
    selectedValue !== "" && onSubmit(selectedValue);
    setReloadItem(!reloadItem);
  };

  const onCancelButton = () => {
    setSelectedAdvertNo("");
    setSelectedExam("");
    setSelectedSubject("");
    setSupervisor("");
    setSelectedYear("");
    setSaveButtonFlag(true);
    setAllAnswerValues([]);
    setReloadItem(!reloadItem);
    allYearList.length = 0;
    examList.length = 0;
    subjectList.length = 0;
    supervisorListById.length = 0;
    examinersAndModeratorReportData.markList &&
      (examinersAndModeratorReportData.markList.length = 0);
    setEditedValues({});
    // setFormData({});
    setEditMode(false);
  };

  const onSubmit = (selectedSupervisor) => {
    dispatch(
      getExaminersAndModeratorReportData(
        selectedExam,
        selectedSubject,
        selectedSupervisor
      )
    );
    setReloadItem(!reloadItem);
  };

  const onSelectYear = (ele) => {
    if (ele == "") {
      onCancelButton();
    } else {
      let selectedValue = ele;
      setSelectedYear(selectedValue);
      selectedValue && dispatch(getAdvertisementlistByYear(selectedValue));
      if (allYearList) {
        allYearList.length = 0;
      }
      if (advertisementList) {
        advertisementList.length = 0;
      }
      if (examList) {
        examList.length = 0;
      }
      if (subjectList) {
        subjectList.length = 0;
      }
      if (supervisorListById) {
        supervisorListById.length = 0;
      }
      if (examinersAndModeratorReportData) {
        examinersAndModeratorReportData.markList &&
          (examinersAndModeratorReportData.markList.length = 0);
      }
      dispatch({
        type: SET_MARKS_PDF,
        payload: {},
      });
      setSaveButtonFlag(true);

      setReloadItem(!reloadItem);
    }
  };

  const handleDifferentialReport = (selectedSubject) => {
    setSaveReportButtonFlag(false);
    if (selectedSubject == "") {
      allMarksPdf = "";
    } else {
      dispatch(
        getExaminersAndModeratorReportDataPDF(selectedExam, selectedSubject)
      );
    }
    // dispatch(getDifferentialReport(selectedExam, selectedSubject))
  };
  const onConfirm = () => {
    if (Object.keys(editedValues).length > 0) {
      const updatedValues = examinersAndModeratorReportData.markList.map(
        (value, index) => {
          const questionNo = index + 1;
          const updatedItem = { ...value, marks: editedValues[questionNo] };

          return editedValues[questionNo] !== undefined ? updatedItem : value;
        }
      );
      setAllAnswerValues(updatedValues);

      dispatch(
        updateExaminersAndModeratorMarksData(
          selectedExam,
          selectedSubject,
          selectedSupervisor,
          updatedValues
        )
      );
    }
    onCancelButton();
    if (allYearList) {
      allYearList.length = 0;
    }
    setEditMode(false);
  };
  const downloadPdf = () => {
    let headData = [[label.BARCODE_NO, label.ROLL_NO, label.MARKS]];
    let rowData = examinersAndModeratorReportData.markList.map((marksDt) => {
      return {
        barcodeNo: marksDt.barcodeNo,
        rollNo: marksDt.rollNo,
        marks: marksDt.marks,
      };
    });
    let headdt = {
      exam_name: "Exam Name",
      subject_name: "Subject Name",
      STUDENT_COUNT: 100,
    };
    let exam_name = examinersAndModeratorReportData.examName;
    let subject_name = examinersAndModeratorReportData.subjectName;
    PrintTablePdf(rowData, headdt, subject_name, exam_name);
    setReloadItem(!reloadItem);
  };

  const genPdf = () => {
    let headerDiv =
      ' <div class="row d-flex flex-column align-items-center"><h5 class="bold-label">' +
      label.MPSC +
      "</h5><h5>" +
      allMarksPdf.examName +
      "</h5><h5>" +
      commonLabels.CODE_AND_CALCULATED_TOTAL +
      "</h5><h5>(" +
      allMarksPdf.subjectName +
      ")</h5></div>";
    const htmlContent = document.createElement("div");
    htmlContent.innerHTML = headerDiv;
    htmlContent.innerHTML += pdfRef?.current?.innerHTML;

    const options = {
      margin: [1, 0.4, 0.7, 0.4],
      filename: "Details_Report.pdf",
      image: { type: "jpeg", quality: 0.95 },
      html2canvas: { scale: 2, dpi: 300, letterRendering: true },
      jsPDF: {
        unit: "in",
        format: "a4",
        orientation: "portrait",
        compressPDF: true,
      },
    };

    html2pdf()
      .from(htmlContent)
      .set(options)
      .toPdf()
      .get("pdf")
      .then((pdf) => {
        const totalPages = pdf.internal.getNumberOfPages();

        for (let i = 1; i <= totalPages; i++) {
          pdf.setPage(i);

          const pageWidth = pdf.internal.pageSize.getWidth();
          const pageHeight = pdf.internal.pageSize.getHeight();
          const textWidth =
            (pdf.getStringUnitWidth(`${i}`) * pdf.internal.getFontSize()) /
            pdf.internal.scaleFactor;
          const textX = pageWidth - textWidth - 1.2;
          const textY = 0.8;
          const currentDate = new Date();
          const formattedDate = currentDate
            .toLocaleDateString("en-GB", {
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
            })
            .split("/")
            .join("/");

          const dateWidth =
            (pdf.getStringUnitWidth(formattedDate) *
              pdf.internal.getFontSize()) /
            pdf.internal.scaleFactor;
          const dateX = pageWidth - dateWidth - 0.4;
          const dateY = 0.6;
          pdf.setFontSize(8);
          pdf.text(formattedDate, dateX, dateY);
          pdf.text(`Page No. ${i}`, dateX, textY);

          const ad = allMarksPdf.advertisementNo;
          const headerText = `Advertisement No. ${ad}`;
          const headerX = 0.4;
          const headerY = 0.6;

          pdf.setFontSize(8);
          pdf.text(headerText, headerX, headerY);
        }

        pdf.save(`Details_Report.pdf`);
      });
  };

  const downloadBarcodeRollPdf = () => {
    let Title = "Barcode and RollNo List";
    let headerDiv =
      ' <div class="row d-flex flex-column align-items-center"><h5 class="bold-label">' +
      label.MPSC +
      "</h5><h5>" +
      barcodeAndRollNoList.examName +
      "</h5><h5>" +
      Title +
      "</h5><h5>(" +
      barcodeAndRollNoList.subjectName +
      ")</h5></div>";
    const htmlContent = document.createElement("div");
    htmlContent.innerHTML = headerDiv;
    htmlContent.innerHTML += pdfRef?.current?.innerHTML;

    const options = {
      margin: [1, 0.2, 0.7, 0.2],
      filename: "BarcodeAndRollNoList.pdf",
      image: { type: "jpeg", quality: 0.95 },
      html2canvas: { scale: 2, dpi: 300, letterRendering: true },
      jsPDF: {
        unit: "in",
        format: "a4",
        orientation: "portrait",
        compressPDF: true,
      },
    };

    html2pdf()
      .from(htmlContent)
      .set(options)
      .toPdf()
      .get("pdf")
      .then((pdf) => {
        const totalPages = pdf.internal.getNumberOfPages();

        for (let i = 1; i <= totalPages; i++) {
          pdf.setPage(i);

          const pageWidth = pdf.internal.pageSize.getWidth();
          const pageHeight = pdf.internal.pageSize.getHeight();
          const textWidth =
            (pdf.getStringUnitWidth(`${i}`) * pdf.internal.getFontSize()) /
            pdf.internal.scaleFactor;
          const textX = pageWidth - textWidth - 1.2;
          const textY = 0.8;
          const currentDate = new Date();
          const formattedDate = currentDate
            .toLocaleDateString("en-GB", {
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
            })
            .split("/")
            .join("/");

          const dateWidth =
            (pdf.getStringUnitWidth(formattedDate) *
              pdf.internal.getFontSize()) /
            pdf.internal.scaleFactor;
          const dateX = pageWidth - dateWidth - 0.4;
          const dateY = 0.6;
          pdf.setFontSize(8);
          pdf.text(formattedDate, dateX, dateY);
          pdf.text(`Page No. ${i}`, dateX, textY);

          const ad = barcodeAndRollNoList.advertisementNo;
          const headerText = `Advertisement No. ${ad}`;
          const headerX = 0.4;
          const headerY = 0.6;

          pdf.setFontSize(8);
          pdf.text(headerText, headerX, headerY);
        }

        pdf.save(`BarcodeAndRollNoList.pdf`);
      });
  };

  const downloadSubjectCodePdf = () => {
    let Title, examName, ad, headerDiv;

    if (selectedSubject) {
      Title = "CODE NUMBER OF CANDIDATES";
      examName = getSubjectCodeRollNo.examName;
      ad = getSubjectCodeRollNo.advertisementNo;
      headerDiv =
        ' <div class="row d-flex flex-column align-items-center"><h5 class="bold-label">' +
        label.MPSC +
        "</h5><h5>" +
        examName +
        "</h5><h5>" +
        Title +
        "</h5><h5>" +
        getSubjectCodeRollNo.subjectName +
        "</h5></div>";
    } else {
      Title = "EXAM CODE OF CANDIDATES";
      examName = getExamCodeRollNo.examName;
      ad = getExamCodeRollNo.advertisementNo;
      headerDiv =
        ' <div class="row d-flex flex-column align-items-center"><h5 class="bold-label">' +
        label.MPSC +
        "</h5><h5>" +
        examName +
        "</h5><h5>" +
        Title +
        "</h5></div>";
    }

    // let headerDiv = ' <div class="row d-flex flex-column align-items-center"><h5 class="bold-label">' + label.MPSC + '</h5><h5>' + examName + '</h5><h5>' + Title + '</h5><h5>(' + getSubjectCodeRollNo.subjectName + ')</h5></div>';
    const htmlContent = document.createElement("div");
    htmlContent.innerHTML = headerDiv;
    htmlContent.innerHTML += pdfRef?.current?.innerHTML;

    const options = {
      margin: [1, 0.2, 0.7, 0.2],
      filename: "CodeRollNo.pdf",
      image: { type: "jpeg", quality: 0.95 },
      html2canvas: { scale: 2, dpi: 300, letterRendering: true },
      jsPDF: {
        unit: "in",
        format: "a4",
        orientation: "portrait",
        compressPDF: true,
      },
    };

    html2pdf()
      .from(htmlContent)
      .set(options)
      .toPdf()
      .get("pdf")
      .then((pdf) => {
        const totalPages = pdf.internal.getNumberOfPages();

        for (let i = 1; i <= totalPages; i++) {
          pdf.setPage(i);

          const pageWidth = pdf.internal.pageSize.getWidth();
          const pageHeight = pdf.internal.pageSize.getHeight();
          const textWidth =
            (pdf.getStringUnitWidth(`${i}`) * pdf.internal.getFontSize()) /
            pdf.internal.scaleFactor;
          const textX = pageWidth - textWidth - 1.2;
          const textY = 0.8;
          const currentDate = new Date();
          const formattedDate = currentDate
            .toLocaleDateString("en-GB", {
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
            })
            .split("/")
            .join("/");

          const dateWidth =
            (pdf.getStringUnitWidth(formattedDate) *
              pdf.internal.getFontSize()) /
            pdf.internal.scaleFactor;
          const dateX = pageWidth - dateWidth - 0.4;
          const dateY = 0.6;
          pdf.setFontSize(8);
          pdf.text(formattedDate, dateX, dateY);
          pdf.text(`Page No. ${i}`, dateX, textY);

          const headerText = `Advertisement No. ${ad}`;
          const headerX = 0.4;
          const headerY = 0.6;

          pdf.setFontSize(8);
          pdf.text(headerText, headerX, headerY);
        }

        if (selectedSubject) {
          pdf.save(`SubjectCodeRollNo.pdf`);
        } else {
          pdf.save(`ExamCodeRollNo.pdf`);
        }
      });
  };

  function downloadCSV() {
    const data = examinersAndModeratorReportData.markList.map((item) => ({
      barcodeNo: item.barcodeNo,
      marks: item.marks,
    }));

    let csvHeader;
    if (selectedSupervisor == "13") {
      csvHeader = ["barcodeNo", "examinerMarks"];
    } else if (selectedSupervisor == "19") {
      csvHeader = ["barcodeNo", "moderatorMarks"];
    } else if (selectedSupervisor == "20") {
      csvHeader = ["barcodeNo", "chiefModeratorMarks"];
    }
    const csvContent =
      "data:text/csv;charset=utf-8," +
      [csvHeader, ...data.map((item) => [item.barcodeNo, item.marks])]
        .map((e) => e.join(","))
        .join("\n");

    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);

    if (selectedSupervisor == "13") {
      link.setAttribute("download", "ExaminerMarks.csv");
    } else if (selectedSupervisor == "19") {
      link.setAttribute("download", "ModeratorMarks.csv");
    } else if (selectedSupervisor == "20") {
      link.setAttribute("download", "ChiefModeratorMarks.csv");
    }

    document.body.appendChild(link);
    link.click();
  }

  const downloadDifferentialReportPdf = () => {

    genPdf();
    setReloadItem(!reloadItem);
  };
  const handleInputChange = (questionNo, newValue) => {
    setEditedValues((prevValues) => ({
      ...prevValues,
      [questionNo]: newValue,
    }));
  };

  const handleApprovalUser = (ele) => {
    setSelectedApprovalEntity(ele);
    setApprovalEntityModal(true);
  };

  const onButtonLockUnlock = (lockStatus) => {
    dispatch(
      requestForLockUnlockStatus(
        selectedExam,
        selectedSubject,
        selectedSupervisor,
        lockStatus,
        onCancelButton
      )
    );
  };

  // const onSaveData = () => {
  //     dispatch(
  //         saveMarksCriteria(selectedExam, selectedSubject, selectedSupervisor, formData));
  // };

  // const patchData = () => {
  //     dispatch(
  //         patchMarksCriteria(selectedExam, selectedSubject, selectedSupervisor, formData));
  // };

  return (
    <div className="commonContentArea">
      <h5 className="labelMargin"> {label.ExaminersAndModeratorReport} </h5>
      <div
        className="tab-content border border-light myTabContent"
        id="myTabContentContainer"
      >
        <ul className="nav nav-tabs" id="myTab" role="tablist">
          {headerField &&
            headerField.map((ele, index) => (
              <li className="nav-item" key={ele.id}>
                <a
                  href="#"
                  className={
                    stepName === ele.id
                      ? "nav-link active"
                      : "nav-link bg-profile-tabs"
                  }
                  value="home"
                  id="home-tab"
                  onClick={() => setName(ele.id)}
                  data-toggle="tab"
                  role="tab"
                  aria-controls="home"
                  aria-selected="false"
                >
                  <span>{ele.name}</span>
                </a>
              </li>
            ))}

          <div className="ml-auto mt-2 d-flex align-items-center justify-content-end flex-wrap">
            <div className="criteria-wrapper mr-3">
              <label className="criteria-label d-block">
                Moderator Criteria
              </label>
              <div className="d-flex align-items-center radio-container">
                <div className="form-check form-check-inline mr-3">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="moderatorCriteria"
                    id="moderatorNo"
                    value="false"
                    checked={moderatorCriteria === "false"}
                    onChange={(e) => {
                      const value = e.target.value;

                      setModeratorCriteria(value);

                      sessionStorage.setItem(
                        "moderatorCriteria",
                        value
                      );

                      window.location.reload();
                    }}
                  />
                  <label
                    className="form-check-label"
                    htmlFor="moderatorNo"
                  >
                    No
                  </label>
                </div>
                <div className="form-check form-check-inline">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="moderatorCriteria"
                    id="moderatorYes"
                    value="true"
                    checked={moderatorCriteria === "true"}
                    onChange={(e) => {
                      const value = e.target.value;

                      setModeratorCriteria(value);

                      sessionStorage.setItem(
                        "moderatorCriteria",
                        value
                      );
                      window.location.reload();
                    }}
                  />

                  <label
                    className="form-check-label"
                    htmlFor="moderatorYes"
                  >
                    Yes
                  </label>
                </div>

              </div>
            </div>
            <div className="criteria-wrapper mr-3">
              <label className="criteria-label d-block">
                Chief Moderator Criteria
              </label>

              <div className="d-flex align-items-center radio-container">

                <div className="form-check form-check-inline mr-3">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="chiefModeratorCriteria"
                    id="chiefModeratorNo"
                    value="false"
                    checked={chiefModeratorCriteria === "false"}
                    onChange={(e) => {
                      const value = e.target.value;

                      setChiefModeratorCriteria(value);

                      sessionStorage.setItem(
                        "chiefModeratorCriteria",
                        value
                      );
                      window.location.reload();
                    }}
                  />
                  <label
                    className="form-check-label"
                    htmlFor="chiefModeratorNo"
                  >
                    No
                  </label>
                </div>

                <div className="form-check form-check-inline">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="chiefModeratorCriteria"
                    id="chiefModeratorYes"
                    value="true"
                    checked={chiefModeratorCriteria === "true"}
                    onChange={(e) => {
                      const value = e.target.value;

                      setChiefModeratorCriteria(value);

                      sessionStorage.setItem(
                        "chiefModeratorCriteria",
                        value
                      );
                      window.location.reload();
                    }}
                  />
                  <label
                    className="form-check-label"
                    htmlFor="chiefModeratorYes"
                  >
                    Yes
                  </label>
                </div>

              </div>
            </div>
            {/* Import Barcode */}
            <button
              type="reset"
              className="btn btn-primary import-button mr-2"
              onClick={() => handledUploadList("barcode")}
            >
              <FiUpload className="mr-2 upload-icon" />
              {commonLabels.BUTTON_IMPORT_BARCODE}
            </button>

            {/* Import Marks */}
            <button
              type="reset"
              className="btn btn-primary import-button"
              onClick={() => handledUploadList("marks")}
            >
              <FiUpload className="mr-2 upload-icon" />
              {commonLabels.BUTTON_IMPORT_MARKS}
            </button>
          </div>
        </ul>
        <div className="tab-content border border-light" id="myTabContent">
          <div
            className={
              stepName === "1"
                ? "tab-pane fade show active"
                : "tab-pane fade styled-tab"
            }
            id="profile"
            role="tabpanel"
            aria-labelledby="profile-tab"
          >
            {examinersAndModeratorApprovalList &&
              examinersAndModeratorApprovalList.entityApprovalDtoList &&
              examinersAndModeratorApprovalList.entityApprovalDtoList.length >
              0 ? (
              <>
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      {unapprovalEntityHeader &&
                        unapprovalEntityHeader.map((itm, ind) => (
                          <th
                            key={ind}
                            className={`${itm === "No." || itm === "Action"
                              ? "text-center"
                              : ""
                              }`}
                          >
                            {itm}
                          </th>
                        ))}
                    </tr>
                  </thead>
                  <tbody>
                    {examinersAndModeratorApprovalList &&
                      examinersAndModeratorApprovalList.entityApprovalDtoList &&
                      examinersAndModeratorApprovalList.entityApprovalDtoList
                        .length > 0 &&
                      examinersAndModeratorApprovalList.entityApprovalDtoList.map(
                        (ele, index) => {
                          return (
                            <tr key={index}>
                              <td className="w-5 text-center">
                                {tableCounter_unapproval++}
                              </td>
                              <td className="word-break">
                                {ele.entityApprovalAction.actionLabel}
                              </td>
                              <td className=" width-5">
                                {ele.entityApprovalAction.level == 1
                                  ? label.APPROVAL_LEVEL_1_PENDING
                                  : ""}
                                {ele.entityApprovalAction.level == 2
                                  ? label.APPROVAL_LEVEL_2_PENDING
                                  : ""}
                                {ele.entityApprovalAction.level == 3
                                  ? label.APPROVAL_LEVEL_3_PENDING
                                  : ""}
                              </td>
                              <td className="word-break width-10">
                                {ele.entityApprovalAction.updatedAt
                                  ? dayjs(
                                    ele.entityApprovalAction.updatedAt
                                  ).format("DD/MM/YYYY h:mm A")
                                  : ""}
                              </td>
                              {/* <td className='text-centerw-10 word-break  text-center width-20'>
                                                    {ele.entityApprovalAction.entityApprovalDto.detail && ele.entityApprovalAction.entityApprovalDto.detail.marks[0].exam && ele.entityApprovalAction.entityApprovalDto.detail.marks[0].exam && ele.entityApprovalAction.entityApprovalDto.detail.marks[0].exam.name} <br /> {ele.entityApprovalAction.entityApprovalDto.detail && ele.entityApprovalAction.entityApprovalDto.detail.exam && ele.entityApprovalAction.entityApprovalDto.detail.marks[0].exam && ele.entityApprovalAction.entityApprovalDto.detail.marks[0].exam.name}
                                              </td> */}
                              <td className="w-10 word-break width-20">
                                {ele.entityApprovalAction.entityApprovalDto
                                  .detail &&
                                  ele.entityApprovalAction.entityApprovalDto
                                    .detail.approvalMarks &&
                                  ele.entityApprovalAction.entityApprovalDto
                                    .detail.approvalMarks[0] &&
                                  ele.entityApprovalAction.entityApprovalDto
                                    .detail.approvalMarks[0].exam &&
                                  ele.entityApprovalAction.entityApprovalDto
                                    .detail.approvalMarks[0].exam.name}
                                <br />
                                {ele.entityApprovalAction.entityApprovalDto
                                  .detail &&
                                  ele.entityApprovalAction.entityApprovalDto
                                    .detail.approvalMarks &&
                                  ele.entityApprovalAction.entityApprovalDto
                                    .detail.approvalMarks[0] &&
                                  ele.entityApprovalAction.entityApprovalDto
                                    .detail.approvalMarks[0].exam &&
                                  ele.entityApprovalAction.entityApprovalDto
                                    .detail.approvalMarks[0].exam.nameDvng}
                              </td>
                              <td className="w-10 word-break  width-12">
                                {ele.entityApprovalAction.entityApprovalDto
                                  .detail &&
                                  ele.entityApprovalAction.entityApprovalDto
                                    .detail.approvalMarks &&
                                  ele.entityApprovalAction.entityApprovalDto
                                    .detail.approvalMarks[0] &&
                                  ele.entityApprovalAction.entityApprovalDto
                                    .detail.approvalMarks[0].subject &&
                                  ele.entityApprovalAction.entityApprovalDto
                                    .detail.approvalMarks[0].subject.name}
                                <br />
                                {ele.entityApprovalAction.entityApprovalDto
                                  .detail &&
                                  ele.entityApprovalAction.entityApprovalDto
                                    .detail.approvalMarks &&
                                  ele.entityApprovalAction.entityApprovalDto
                                    .detail.approvalMarks[0] &&
                                  ele.entityApprovalAction.entityApprovalDto
                                    .detail.approvalMarks[0].subject &&
                                  ele.entityApprovalAction.entityApprovalDto
                                    .detail.approvalMarks[0].subject.nameDvng}
                              </td>
                              <td >
                                {ele.entityApprovalAction.entityApprovalDto.entityMaster.name.replace(
                                  "_",
                                  " "
                                )}
                              </td>
                              <td >
                                {
                                  ele.entityApprovalAction.entityApprovalDto
                                    .approvalTypeLabel
                                }
                              </td>
                              <td className=" word-break">
                                {
                                  ele.entityApprovalAction.actionByUser
                                    .firstName
                                }{" "}
                                {ele.entityApprovalAction.actionByUser.lastName}
                              </td>
                              <td className=" word-break">
                                {ele.entityApprovalAction.comments}
                              </td>
                              <td className="text-center word-break width-15">
                                {(session.roleName == "superadmin" ||
                                  session.roleName == "desk officer") && (
                                    <button
                                      type="button"
                                      className="mx-auto btn btn-outline-primary btn-sm custom-button"
                                      onClick={() => {
                                        handleApprovalUser(ele);
                                      }}
                                    >
                                      {label.REVIEW}
                                    </button>
                                  )}
                              </td>
                            </tr>
                          );
                        }
                      )}
                  </tbody>
                </table>
                <TablePagination
                  paginationFor="un_answerkey_list"
                  rowPerPage={rowPerPage}
                  setListCurrentPage={setListCurrentPage}
                  totalCount={
                    examinersAndModeratorApprovalList.totalNoOfRecords
                  }
                />
              </>
            ) : (
              <div className="text-center width-lg-ap">
                <font className="text-danger">
                  {commonLabels.NO_DATA_FOUND}
                </font>
              </div>
            )}
          </div>
          <div
            className={
              stepName === "2"
                ? "tab-pane fade show active"
                : "tab-pane fade styled-tab"
            }
            id="profile"
            role="tabpanel"
            aria-labelledby="profile-tab"
          >
            <div className="row dashboardCards">
              <div className="col-md-12 ">
                <form name="importForm" encType="multipart/form-data">
                  <div className="form-group">
                    <div className="row"></div>
                    <div>
                      <div className="row">
                        <div className="form-group col-md-2">
                          <label className="float-left">
                            {commonLabels.selectYear}
                            <span className="errorText">*</span>
                          </label>
                          <select
                            className="form-control"
                            name="selectedYear"
                            value={selectedYear}
                            // ref={register({ required: true })}
                            onChange={(e) => {
                              onSelectYear(e.target.value);
                            }}
                          >
                            <option key={0} value="">
                              {commonLabels.COMBO_SELECT}
                            </option>
                            {yearList &&
                              yearList.length > 0 &&
                              yearList.map((element, index) => (
                                <option>{element}</option>
                                // <option key={index} value={element.id}>
                                //   {`${element.advertisementNo}/${element.year} - ${element.name}`}
                                // </option>
                              ))}
                          </select>
                          {_.get("selectedYear.type", errors) ===
                            "required" && (
                              <p className="errorText float-left">
                                {commonLabels.MANDATORY_FIELD_MESSAGE}
                              </p>
                            )}
                        </div>
                        <div className="form-group col-md-4">
                          <label className="float-left">
                            {commonLabels.SelectAdvertNo}
                            <span className="errorText">*</span>
                          </label>
                          <select
                            className="form-control"
                            name="selectedAdvertiseNo"
                            // value={selectedAdvertNo}
                            ref={register({ required: true })}
                            onChange={(e) => {
                              onAdvertisementChange(e.target.value);
                            }}
                          >
                            <option key={0} value="">
                              {commonLabels.COMBO_SELECT}
                            </option>
                            {allYearList &&
                              allYearList.length > 0 &&
                              allYearList
                                .filter(
                                  (element) =>
                                    element.isDeleted == false &&
                                    element.isActive === true
                                )
                                .map((element, index) => (
                                  <option key={index} value={element.id}>
                                    {`${element.advertisementNo}/${element.year} - ${element.name}`}
                                  </option>
                                ))}
                          </select>
                          {_.get("selectedAdvertiseNo.type", errors) ===
                            "required" && (
                              <p className="errorText float-left">
                                {commonLabels.MANDATORY_FIELD_MESSAGE}
                              </p>
                            )}
                        </div>

                        <div className=" col-md-3">
                          <label className="float-left">
                            {label.SelectExam}
                            <span className="errorText">*</span>
                          </label>
                          <select
                            className="form-control"
                            name="selectedExam"
                            // value={selectedExam}
                            ref={register({ required: true })}
                            onChange={(e) => {
                              onExamChange(e.target.value);
                            }}
                          >
                            <option key={0} value="">
                              {commonLabels.COMBO_SELECT}
                            </option>
                            {examList &&
                              examList.length > 0 &&
                              examList
                                .filter(
                                  (element) =>
                                    element.isDeleted == false &&
                                    element.isActive === true
                                )
                                .map((element, index) => (
                                  <option key={index} value={element.id}>
                                    {element.name}
                                  </option>
                                ))}
                          </select>
                          {_.get("selectedExam.type", errors) ===
                            "required" && (
                              <p className="errorText float-left">
                                {commonLabels.MANDATORY_FIELD_MESSAGE}
                              </p>
                            )}
                        </div>

                        <div className=" col-md-3">
                          <label className="float-left">
                            {label.SelectSubject}
                            <span className="errorText">*</span>
                          </label>
                          <select
                            className="form-control"
                            name="selectedSubject"
                            // value={selectedSubject}
                            ref={register({ required: true })}
                            onChange={(e) => {
                              onSubjectChange(e.target.value);
                            }}
                          >
                            <option key={0} value="">
                              {commonLabels.COMBO_SELECT}
                            </option>
                            {
                              subjectList &&
                              subjectList.length > 0 &&
                              subjectList
                                // .filter(
                                //   (element) =>
                                //     element.isDeleted == false &&
                                //     element.isActive === true
                                // )
                                .map((element, index) => (
                                  <option key={index} value={element.id}>
                                    {element.name}({element.type?.toUpperCase()})
                                  </option>
                                ))
                            }
                          </select>
                          {_.get("selectedSubject.type", errors) === "required" && (
                            <p className="errorText float-left">
                              {commonLabels.MANDATORY_FIELD_MESSAGE}
                            </p>
                          )}
                        </div>
                        <div className=" col-md-3">
                          <label className="float-left">
                            {label.SelectSupervisor}
                            <span className="errorText">*</span>
                          </label>
                          <select
                            className="form-control"
                            name="selectedSupervisor"
                            // value={selectedSupervisor}
                            ref={register({ required: true })}
                            onChange={(e) => {
                              onSupervisorChange(e.target.value);
                            }}
                          >
                            <option key={0} value="">
                              {commonLabels.COMBO_SELECT}
                            </option>
                            {
                              supervisorListById &&
                              supervisorListById.length > 0 &&
                              supervisorListById
                                .map((element, index) => {
                                  if (session.roleName === 'superadmin' || (session.roleName === 'examiner' && element.role === 'examiner') || (session.roleName === 'moderator' && element.role === 'moderator') || (session.roleName === 'chiefmoderator' && element.role === 'chiefmoderator')) {
                                    return (
                                      <option key={index} value={element.userId}>
                                        {element.role}
                                      </option>
                                    )
                                  }
                                  return null;
                                })
                            }
                          </select>
                          {_.get("selectedSupervisor.type", errors) === "required" && (
                            <p className="errorText float-left">
                              {commonLabels.MANDATORY_FIELD_MESSAGE}
                            </p>
                          )}
                        </div>
                      </div>
                      <div className="row">
                        <div className=" col-md-8">
                          <button
                            type="reset"
                            className="btn btn-secondary mr-2"
                            onClick={() => onCancelButton()}
                          >
                            {commonLabels.BUTTON_CANCEL}
                          </button>

                          <button
                            type="button"
                            className="btn btn-primary mr-2"
                            disabled={
                              saveButtonFlag ||
                              editMode ||
                              (examinersAndModeratorReportData.isSupervisorLocked &&
                                examinersAndModeratorReportData.isSupervisorLocked) ||
                              !examinersAndModeratorReportData.markList
                            }
                            onClick={() => setEditMode(true)}
                          >
                            {commonLabels.BUTTON_EDIT}
                          </button>

                          <button
                            type="button"
                            className="btn btn-primary mr-2"
                            disabled={saveButtonFlag || !editMode}
                            onClick={() => {
                              onConfirm();
                            }}
                          >
                            {commonLabels.BUTTON_CONFIRM}
                          </button>

                          {(session.roleName == "superadmin" ||
                            session.roleName == "secretary") && (
                              <button
                                type="button"
                                className="btn btn-primary mr-2"
                                disabled={saveButtonFlag || !examinersAndModeratorReportData.markList}
                                onClick={() => {
                                  downloadCSV();
                                }}
                              >
                                {commonLabels.BUTTON_PRINT}
                              </button>
                            )}

                          {/* <button
                            type="button"
                            className="btn btn-primary mr-2"
                            hidden={editMode || saveButtonFlag}
                            onClick={() =>
                              onButtonLockUnlock(
                                !examinersAndModeratorReportData.isSupervisorLocked
                              )
                            }
                          >
                            {examinersAndModeratorReportData.isSupervisorLocked
                              ? commonLabels.BUTTON_UNLOCK
                              : commonLabels.BUTTON_LOCK}
                          </button> */}
                          <button
                            type="button"
                            className={`btn mr-2 ${examinersAndModeratorReportData.isSupervisorLocked
                              ? "btn-lock-green"
                              : "btn-unlock-red"
                              }`}
                            style={{
                              borderRadius: "0.60rem",
                            }}
                            hidden={editMode || saveButtonFlag}
                            onClick={() =>
                              onButtonLockUnlock(
                                !examinersAndModeratorReportData.isSupervisorLocked
                              )
                            }
                          >
                            {examinersAndModeratorReportData.isSupervisorLocked
                              ? commonLabels.BUTTON_UNLOCK
                              : commonLabels.BUTTON_LOCK}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            {examinersAndModeratorReportData &&
              examinersAndModeratorReportData.markList &&
              examinersAndModeratorReportData.markList.length > 0 && (
                <div className="answerKeyTable" id="AnswerKey">
                  <div className="row bottom-padding ml-0 align-items-center">
                    <div className="p-3 mr-3">
                      <div className="d-flex align-items-center flex-wrap">
                        <div className="mr-5">
                          <span className="bold-label">
                            {label.EXAM_NAME}
                          </span>
                          <span className="LeftText ml-1">
                            {examinersAndModeratorReportData.examName}
                          </span>
                        </div>
                        <div>
                          <span className="bold-label">
                            {label.SUBJECT_NAME}
                          </span>
                          <span className="LeftText ml-1">
                            {examinersAndModeratorReportData.subjectName}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <table className="table table-bordered text-center">
                    <thead className="thead-light">
                      <tr>
                        <th className="text-center">{label.BARCODE_NO}</th>
                        {/* <th>{label.ROLL_NO}</th> */}
                        <th>{label.MARKS}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {examinersAndModeratorReportData.markList.map(
                        (marksDt, i) => {
                          return (
                            <tr key={i}>
                              <td className="text-center">{marksDt.barcodeNo}</td>
                              {/* <td>{marksDt.rollNo}</td> */}
                              <td>
                                {editMode ? (
                                  <input
                                    type="text"
                                    defaultValue={marksDt.marks}
                                    value={editedValues[i + 1]}
                                    onChange={(e) =>
                                      handleInputChange(i + 1, e.target.value)
                                    }
                                    className={
                                      editMode
                                        ? "editable-input-box"
                                        : "input-box"
                                    }
                                    onKeyPress={(e) => {
                                      if (!/[0-9]/.test(e.key)) {
                                        e.preventDefault();
                                      }
                                    }}
                                    maxLength="3"
                                  />
                                ) : (
                                  <span>{marksDt.marks}</span>
                                )}
                              </td>
                            </tr>
                          );
                        }
                      )}
                    </tbody>
                  </table>
                </div>
              )}
          </div>
          <div
            className={
              stepName === "3"
                ? "tab-pane fade show active"
                : "tab-pane fade styled-tab"
            }
            id="profile"
            role="tabpanel"
            aria-labelledby="profile-tab"
          >
            <div className="row dashboardCards">
              <div className="col-md-12 ">
                <form name="importForm" encType="multipart/form-data">
                  <div className="form-group ">
                    <div className="row"></div>
                    <div>
                      <div className="row">
                        <div className="form-group col-md-2">
                          <label className="float-left">
                            {commonLabels.selectYear}
                            <span className="errorText">*</span>
                          </label>
                          <select
                            className="form-control"
                            name="selectedYear1"
                            ref={register({ required: true })}
                            onChange={(e) => {
                              onSelectYear(e.target.value);
                            }}
                          >
                            <option key={0} value="">
                              {commonLabels.COMBO_SELECT}
                            </option>
                            {yearList &&
                              yearList.length > 0 &&
                              yearList.map((element, index) => (
                                <option>{element}</option>
                                // <option key={index} value={element.id}>
                                //   {`${element.advertisementNo}/${element.year} - ${element.name}`}
                                // </option>
                              ))}
                          </select>
                          {_.get("selectedYear1.type", errors) ===
                            "required" && (
                              <p className="errorText float-left">
                                {commonLabels.MANDATORY_FIELD_MESSAGE}
                              </p>
                            )}
                        </div>
                        <div className="form-group col-md-4">
                          <label className="float-left">
                            {commonLabels.SelectAdvertNo}
                            <span className="errorText">*</span>
                          </label>
                          <select
                            className="form-control"
                            name="selectedAdvertiseNo1"
                            ref={register({ required: true })}
                            onChange={(e) => {
                              onAdvertisementChange(e.target.value);
                            }}
                          >
                            <option key={0} value="">
                              {commonLabels.COMBO_SELECT}
                            </option>
                            {allYearList &&
                              allYearList.length > 0 &&
                              allYearList
                                .filter(
                                  (element) =>
                                    element.isDeleted == false &&
                                    element.isActive === true
                                )
                                .map((element, index) => (
                                  <option key={index} value={element.id}>
                                    {`${element.advertisementNo}/${element.year} - ${element.name}`}
                                  </option>
                                ))}
                          </select>
                          {_.get("selectedAdvertiseNo1.type", errors) ===
                            "required" && (
                              <p className="errorText float-left">
                                {commonLabels.MANDATORY_FIELD_MESSAGE}
                              </p>
                            )}
                        </div>
                        <div className=" col-md-3">
                          <label className="float-left">
                            {label.SelectExam}
                            <span className="errorText">*</span>
                          </label>
                          <select
                            className="form-control"
                            name="selectedExam1"
                            // value={selectedExam}
                            ref={register({ required: true })}
                            onChange={(e) => {
                              onExamChange(e.target.value);
                            }}
                          >
                            <option>{commonLabels.COMBO_SELECT}</option>
                            {examList &&
                              examList.length > 0 &&
                              examList
                                .filter(
                                  (element) =>
                                    element.isDeleted == false &&
                                    element.isActive === true
                                )
                                .map((element, index) => (
                                  <option key={index} value={element.id}>
                                    {element.name}
                                  </option>
                                ))}
                          </select>
                          {_.get("selectedExam1.type", errors) ===
                            "required" && (
                              <p className="errorText float-left">
                                {commonLabels.MANDATORY_FIELD_MESSAGE}
                              </p>
                            )}
                        </div>
                        <div className=" col-md-3">
                          <label className="float-left">
                            {label.SelectSubject}
                            <span className="errorText">*</span>
                          </label>
                          <select
                            className="form-control"
                            name="selectedSubject1"
                            // value={selectedSubject}
                            ref={register({ required: true })}
                            onChange={(e) => {
                              //   onSubjectChange(e.target.value);
                              handleDifferentialReport(e.target.value);
                            }}
                          >
                            <option key={0} value="">
                              {commonLabels.COMBO_SELECT}
                            </option>
                            {subjectList &&
                              subjectList.length > 0 &&
                              subjectList
                                // .filter(
                                //   (element) =>
                                //     element.isDeleted == false &&
                                //     element.isActive === true
                                // )
                                .map((element, index) => (
                                  <option key={index} value={element.id}>
                                    {element.name}({element.type?.toUpperCase()})
                                  </option>
                                ))}
                          </select>
                          {_.get("selectedSubject1.type", errors) ===
                            "required" && (
                              <p className="errorText float-left">
                                {commonLabels.MANDATORY_FIELD_MESSAGE}
                              </p>
                            )}
                        </div>
                      </div>
                      {(session.roleName == "superadmin" ||
                        session.roleName == "secretary") && (
                          <div className="row">
                            <div className=" col-md-8">
                              <button
                                type="button"
                                className="btn btn-primary mr-2"
                                disabled={saveReportButtonFlag || !allMarksPdf.marks}
                                onClick={() => {
                                  downloadDifferentialReportPdf();
                                }}
                              >
                                {commonLabels.BUTTON_PRINT}
                              </button>
                            </div>
                          </div>
                        )}
                    </div>
                  </div>
                </form>
              </div>
            </div>

            {allMarksPdf && allMarksPdf.advertisementNo && (
              <div ref={pdfRef} className="answerKeyTable" id="AnswerKey">
                <table className="table table-bordered text-center">
                  <thead className="thead-light">
                    <tr>
                      <th className="text-center">{label.BARCODE_NO}</th>
                      <th className="text-center">{label.examinerMarks}</th>
                      <th className="text-center">{label.moderatorMarks}</th>
                      <th className="text-center">{label.chiefModeratorMarks}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {allMarksPdf?.marks?.map((marksDt, i) => (
                      <tr key={i}>
                        <td>{marksDt.barcodeNo}</td>
                        <td>{marksDt.examinerMarks || "-"}</td>
                        <td>{marksDt.moderatorMarks || "-"}</td>
                        <td>{marksDt.chiefModeratorMarks || "-"}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
            {/* <div className="row bottom-padding">
                              <div className="form-group col-md-2 mb-0">
                                  <label className="LeftText bold-label">{label.EXAM_NAME}</label>
                              </div>
                              <div className="form-group col-md-4 mb-0">
                                  <label className="LeftText">
                                      { differentialReportData[0].examinerMarks!== null && differentialReportData[0].examinerMarks.exam.name || 
                                        differentialReportData[0].moderatorMarks!== null && differentialReportData[0].moderatorMarks.exam.name || 
                                        differentialReportData[0].chiefModeratorMarks!== null && differentialReportData[0].chiefModeratorMarks.exam.name}
                                  </label>
                              </div>
                              <div className="form-group col-md-2 mb-0">
                                  <label className="LeftText bold-label">{label.SUBJECT_NAME}</label>
                              </div>
                              <div className="form-group col-md-4 mb-0">
                                  <label className="LeftText">
                                  { differentialReportData[0].examinerMarks!== null && differentialReportData[0].examinerMarks.subject.name || 
                                    differentialReportData[0].moderatorMarks!== null && differentialReportData[0].moderatorMarks.subject.name || 
                                    differentialReportData[0].chiefModeratorMarks!== null && differentialReportData[0].chiefModeratorMarks.subject.name }
                                  </label>
                              </div>
                          </div> */}
            {/* <table className="table table-bordered">
                              <thead className="thead-light">
                                  <tr>
                                      <th>{label.BARCODE_NO}</th>
                                      <th>{label.EXAMINER_MARK}</th>
                                      <th>{label.MODERATOR_MARKS}</th>
                                      <th>{label.CHIEF_MODERATOR_MARK}</th>
                                  </tr>
                              </thead>
                              <tbody>
                              {
                                differentialReportData.map((marksDt, i)=>{
                                    return  <tr key={i}>
                                                <td>{marksDt.barcodeNo}</td>
                                                <td>{marksDt.examinerMarks ? marksDt.examinerMarks.marks : 'NA'}</td>
                                                <td>{marksDt.moderatorMarks ? marksDt.moderatorMarks.marks : 'NA'}</td>
                                                <td>{marksDt.chiefModeratorMarks ? marksDt.chiefModeratorMarks.marks : 'NA'}</td>
                                            </tr>
                                })
                              }
                              </tbody>
                          </table>
                      </div>
                  )} */}
          </div>
          <div
            className={
              stepName === "4"
                ? "tab-pane fade show active"
                : "tab-pane fade styled-tab"
            }
            id="profile"
            role="tabpanel"
            aria-labelledby="profile-tab"
          >
            <div className="row dashboardCards">
              <div className="col-md-12 ">
                <form name="importForm" encType="multipart/form-data">
                  <div className="form-group">
                    <div className="row"></div>
                    <div>
                      <div className="row">
                        <div className="form-group col-md-2">
                          <label className="float-left">
                            {commonLabels.selectYear}
                            <span className="errorText">*</span>
                          </label>
                          <select
                            className="form-control"
                            name="selectedYear4"
                            value={selectedYear}
                            // ref={register({ required: true })}
                            onChange={(e) => {
                              onSelectYear(e.target.value);
                            }}
                          >
                            <option key={0} value="">
                              {commonLabels.COMBO_SELECT}
                            </option>
                            {yearList &&
                              yearList.length > 0 &&
                              yearList.map((element, index) => (
                                <option key={index}>{element}</option>
                                // <option key={index} value={element.id}>
                                //   {`${element.advertisementNo}/${element.year} - ${element.name}`}
                                // </option>
                              ))}
                          </select>
                          {_.get("selectedYear4.type", errors) ===
                            "required" && (
                              <p className="errorText float-left">
                                {commonLabels.MANDATORY_FIELD_MESSAGE}
                              </p>
                            )}
                        </div>
                        <div className="form-group col-md-4">
                          <label className="float-left">
                            {commonLabels.SelectAdvertNo}
                            <span className="errorText">*</span>
                          </label>
                          <select
                            className="form-control"
                            name="selectedAdvertiseNo4"
                            // value={selectedAdvertNo}
                            ref={register({ required: true })}
                            onChange={(e) => {
                              onAdvertisementChange(e.target.value);
                            }}
                          >
                            <option key={0} value="">
                              {commonLabels.COMBO_SELECT}
                            </option>
                            {allYearList &&
                              allYearList.length > 0 &&
                              allYearList
                                .filter(
                                  (element) =>
                                    element.isDeleted == false &&
                                    element.isActive === true
                                )
                                .map((element, index) => (
                                  <option key={index} value={element.id}>
                                    {`${element.advertisementNo}/${element.year} - ${element.name}`}
                                  </option>
                                ))}
                          </select>
                          {_.get("selectedAdvertiseNo4.type", errors) ===
                            "required" && (
                              <p className="errorText float-left">
                                {commonLabels.MANDATORY_FIELD_MESSAGE}
                              </p>
                            )}
                        </div>
                        <div className="col-md-3">
                          <label className="float-left">
                            {label.SelectExam}
                            <span className="errorText">*</span>
                          </label>
                          <select
                            className="form-control"
                            name="selectedExam4"
                            // value={selectedExam}
                            ref={register({ required: true })}
                            onChange={(e) => {
                              onExamChange(e.target.value);
                            }}
                          >
                            <option key={0} value="">
                              {commonLabels.COMBO_SELECT}
                            </option>
                            {examList &&
                              examList.length > 0 &&
                              examList
                                .filter(
                                  (element) =>
                                    element.isDeleted == false &&
                                    element.isActive === true
                                )
                                .map((element, index) => (
                                  <option key={index} value={element.id}>
                                    {element.name}
                                  </option>
                                ))}
                          </select>
                          {_.get("selectedExam4.type", errors) ===
                            "required" && (
                              <p className="errorText float-left">
                                {commonLabels.MANDATORY_FIELD_MESSAGE}
                              </p>
                            )}
                        </div>
                        <div className=" col-md-3">
                          <label className="float-left">
                            {label.SelectSubject}
                            <span className="errorText">*</span>
                          </label>
                          <select
                            className="form-control"
                            name="selectedSubject4"
                            // value={selectedSubject}
                            ref={register({ required: true })}
                            onChange={(e) => {
                              onSubjectChange(e.target.value);
                              setSaveButtonFlag(false);
                            }}
                          >
                            <option key={0} value="">
                              {commonLabels.COMBO_SELECT}
                            </option>
                            {subjectList &&
                              subjectList.length > 0 &&
                              subjectList
                                // .filter(
                                //   (element) =>
                                //     element.isDeleted == false &&
                                //     element.isActive === true
                                // )
                                .map((element, index) => (
                                  <option key={index} value={element.id}>
                                    {element.name} ({element.type?.toUpperCase()})
                                  </option>
                                ))}
                          </select>
                          {_.get("selectedSubject4.type", errors) ===
                            "required" && (
                              <p className="errorText float-left">
                                {commonLabels.MANDATORY_FIELD_MESSAGE}
                              </p>
                            )}
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-8">
                          <button
                            type="reset"
                            className="btn btn-secondary mr-2"
                            onClick={() => onCancelButton()}
                          >
                            {commonLabels.BUTTON_CANCEL}
                          </button>
                          {(session.roleName == "superadmin" ||
                            session.roleName == "secretary") && (
                              <button
                                type="button"
                                className="btn btn-primary mr-2"
                                disabled={
                                  saveButtonFlag || barcodeAndRollNo.length == 0
                                }
                                onClick={() => {
                                  downloadBarcodeRollPdf();
                                }}
                              >
                                {commonLabels.BUTTON_PRINT}
                              </button>
                            )}
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            {/* {selectedSubject &&
              barcodeAndRollNo &&
              barcodeAndRollNo.length > 0 && (
                <div ref={pdfRef}>
                  <table className="table table-bordered text-center">
                    <thead className="thead-light">
                      <tr>
                        {[...Array(5)].map((_, index) => (
                          <React.Fragment key={index}>
                            <th className="text-nowrap small font-weight-bold text-center">
                              {label.BARCODE_NO}
                            </th>
                            <th className="text-nowrap small font-weight-bold text-center">
                              {label.ROLL_NO}
                            </th>
                          </React.Fragment>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {[...Array(Math.ceil(barcodeAndRollNo.length / 5))].map(
                        (_, rowIndex) => (
                          <tr key={rowIndex}>
                            {[...Array(5)].map((_, colIndex) => {
                              const dataIndex = rowIndex * 5 + colIndex;
                              const marksDt = barcodeAndRollNo[dataIndex];
                              return (
                                <React.Fragment key={colIndex}>
                                  <td className="text-center">
                                    <strong>
                                      {marksDt ? marksDt.barcodeNo : ""}
                                    </strong>
                                  </td>
                                  <td className="text-center">{marksDt ? marksDt.rollNo : ""}</td>
                                </React.Fragment>
                              );
                            })}
                          </tr>
                        )
                      )}
                    </tbody>
                  </table>
                </div>
              )} */}
            {barcodeAndRollNo?.length > 0 && (
              <div ref={pdfRef} className="table-responsive">
                <table
                  className="table table-bordered text-center custom-table"
                >
                  <thead className="thead-light">
                    <tr>
                      {[...Array(5)].map((_, index) => (
                        <React.Fragment key={index}>
                          <th className="text-nowrap small font-weight-bold">
                            {label.BARCODE_NO}
                          </th>
                          <th className="text-nowrap small font-weight-bold">
                            {label.ROLL_NO}
                          </th>
                        </React.Fragment>
                      ))}
                    </tr>
                  </thead>

                  <tbody>
                    {[...Array(Math.ceil(barcodeAndRollNo.length / 5))].map(
                      (_, rowIndex) => (
                        <tr key={rowIndex}>
                          {[...Array(5)].map((_, colIndex) => {
                            const dataIndex = rowIndex * 5 + colIndex;
                            const marksDt = barcodeAndRollNo[dataIndex];

                            return (
                              <React.Fragment key={colIndex}>
                                <td className="text-nowrap">
                                  <strong>
                                    {marksDt ? marksDt.barcodeNo : ""}
                                  </strong>
                                </td>
                                <td className="text-nowrap">
                                  {marksDt ? marksDt.rollNo : ""}
                                </td>
                              </React.Fragment>
                            );
                          })}
                        </tr>
                      )
                    )}
                  </tbody>
                </table>
              </div>
            )}
          </div>

          <div
            className={
              stepName === "5"
                ? "tab-pane fade show active"
                : "tab-pane fade styled-tab"
            }
            id="profile"
            role="tabpanel"
            aria-labelledby="profile-tab"
          >
            <div className="row dashboardCards">
              <div className="col-md-12 ">
                <form name="importForm" encType="multipart/form-data">
                  <div className="form-group">
                    <div className="row"></div>
                    <div>
                      <div className="row">
                        <div className="form-group col-md-2">
                          <label className="float-left">
                            {commonLabels.selectYear}
                            <span className="errorText">*</span>
                          </label>
                          <select
                            className="form-control"
                            name="selectedYear5"
                            value={selectedYear}
                            // ref={register({ required: true })}
                            onChange={(e) => {
                              onSelectYear(e.target.value);
                            }}
                          >
                            <option key={0} value="">
                              {commonLabels.COMBO_SELECT}
                            </option>
                            {yearList &&
                              yearList.length > 0 &&
                              yearList.map((element, index) => (
                                <option key={index}>{element}</option>
                                // <option key={index} value={element.id}>
                                //   {`${element.advertisementNo}/${element.year} - ${element.name}`}
                                // </option>
                              ))}
                          </select>
                          {_.get("selectedYear5.type", errors) ===
                            "required" && (
                              <p className="errorText float-left">
                                {commonLabels.MANDATORY_FIELD_MESSAGE}
                              </p>
                            )}
                        </div>
                        <div className="form-group col-md-4">
                          <label className="float-left">
                            {commonLabels.SelectAdvertNo}
                            <span className="errorText">*</span>
                          </label>
                          <select
                            className="form-control"
                            name="selectedAdvertiseNo5"
                            // value={selectedAdvertNo}
                            ref={register({ required: true })}
                            onChange={(e) => {
                              onAdvertisementChange(e.target.value);
                            }}
                          >
                            <option key={0} value="">
                              {commonLabels.COMBO_SELECT}
                            </option>
                            {allYearList &&
                              allYearList.length > 0 &&
                              allYearList
                                .filter(
                                  (element) =>
                                    element.isDeleted == false &&
                                    element.isActive === true
                                )
                                .map((element, index) => (
                                  <option key={index} value={element.id}>
                                    {`${element.advertisementNo}/${element.year} - ${element.name}`}
                                  </option>
                                ))}
                          </select>
                          {_.get("selectedAdvertiseNo5.type", errors) ===
                            "required" && (
                              <p className="errorText float-left">
                                {commonLabels.MANDATORY_FIELD_MESSAGE}
                              </p>
                            )}
                        </div>
                        <div className=" col-md-3">
                          <label className="float-left">
                            {label.SelectExam}
                            <span className="errorText">*</span>
                          </label>
                          <select
                            className="form-control"
                            name="selectedExam5"
                            // value={selectedExam}
                            ref={register({ required: true })}
                            onChange={(e) => {
                              onExamChange(e.target.value);
                            }}
                          >
                            <option key={0} value="">
                              {commonLabels.COMBO_SELECT}
                            </option>
                            {examList &&
                              examList.length > 0 &&
                              examList
                                .filter(
                                  (element) =>
                                    element.isDeleted == false &&
                                    element.isActive === true
                                )
                                .map((element, index) => (
                                  <option key={index} value={element.id}>
                                    {element.name}
                                  </option>
                                ))}
                          </select>
                          {_.get("selectedExam5.type", errors) ===
                            "required" && (
                              <p className="errorText float-left">
                                {commonLabels.MANDATORY_FIELD_MESSAGE}
                              </p>
                            )}
                        </div>
                        <div className=" col-md-3">
                          <label className="float-left">
                            {label.SelectSubject}
                          </label>
                          <select
                            className="form-control"
                            name="selectedSubject5"
                            // value={selectedSubject}
                            onChange={(e) => {
                              onSubjectChange(e.target.value);
                              setSaveButtonFlag(false);
                            }}
                          >
                            <option key={0} value="">
                              {commonLabels.COMBO_SELECT}
                            </option>
                            {subjectList &&
                              subjectList.length > 0 &&
                              subjectList
                                // .filter(
                                //   (element) =>
                                //     element.isDeleted == false &&
                                //     element.isActive === true
                                // )
                                .map((element, index) => (
                                  <option key={index} value={element.id}>
                                    {element.name} ({element.type?.toUpperCase()})
                                  </option>
                                ))}
                          </select>
                        </div>
                      </div>
                      <div className="row">
                        <div className=" col-md-8">
                          <button
                            type="reset"
                            className="btn btn-secondary mr-2"
                            onClick={() => onCancelButton()}
                          >
                            {commonLabels.BUTTON_CANCEL}
                          </button>
                          {(session.roleName == "superadmin" ||
                            session.roleName == "secretary") && (
                              <button
                                type="button"
                                className="btn btn-primary mr-2"
                                disabled={saveButtonFlag || !getSubjectCodeRollNo.codeNoMarathiEnglishRecordsDtos}
                                onClick={() => {
                                  downloadSubjectCodePdf();
                                }}
                              >
                                {commonLabels.BUTTON_PRINT}
                              </button>
                            )}
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>

            {selectedSubject &&
              getSubjectCodeRollNo &&
              getSubjectCodeRollNo.codeNoMarathiEnglishRecordsDtos &&
              getSubjectCodeRollNo?.codeNoMarathiEnglishRecordsDtos.length >
              0 && (
                <div ref={pdfRef}>
                  <table className="table table-bordered text-center">
                    <thead className="thead-light">
                      <tr>
                        <th className="text-center" id="topbotborder">Sr. No.</th>
                        <th className="text-center" id="topbotborder">Roll No</th>
                        <th className="text-center" id="topbotborder">Code No</th>
                        <th className="text-center" id="topbotborder">Sr. No.</th>
                        <th className="text-center" id="topbotborder">Roll No</th>
                        <th className="text-center" id="topbotborder">Code No</th>
                        <th className="text-center" id="topbotborder">Sr. No.</th>
                        <th className="text-center" id="topbotborder">Roll No</th>
                        <th className="text-center" id="topbotborder">Code No</th>
                      </tr>
                    </thead>
                    <tbody>
                      {[
                        ...Array(
                          Math.ceil(
                            getSubjectCodeRollNo.codeNoMarathiEnglishRecordsDtos
                              .length / 3
                          )
                        ),
                      ].map((_, rowIndex) => (
                        <tr key={rowIndex}>
                          {[0, 1, 2].map((colIndex) => {
                            const dataIndex = rowIndex * 3 + colIndex;
                            const record =
                              getSubjectCodeRollNo
                                .codeNoMarathiEnglishRecordsDtos[dataIndex];

                            return (
                              <React.Fragment key={colIndex}>
                                <td className="text-center" id="bottomborder">
                                  {record ? record.serialNo : "-"}
                                </td>
                                <td className="text-center" id="bottomborder">
                                  {record ? record.rollNo : "-"}
                                </td>
                                <td className="text-center" id="bottomborder">
                                  {record ? record.codeNo : "-"}
                                </td>
                              </React.Fragment>
                            );
                          })}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}

            {!selectedSubject &&
              selectedExam &&
              getExamCodeRollNo &&
              getExamCodeRollNo.examCodeRollNoDtos &&
              getExamCodeRollNo?.examCodeRollNoDtos.length > 0 && (
                <div ref={pdfRef}>
                  <div className="d-flex justify-content-between"
                  >
                    <div className="w-50">
                      <table className="table table-bordered text-center">
                        <thead className="thead-light">
                          <tr>
                            <th className="text-center">Sr. No.</th>
                            <th className="text-center">Roll No</th>
                            {getExamCodeRollNo.examCodeRollNoDtos[0]?.code.map(
                              (subject, index) => (
                                <React.Fragment key={index}>
                                  <th>{subject.subjectName}</th>
                                </React.Fragment>
                              )
                            )}
                          </tr>
                        </thead>
                        <tbody >
                          {getExamCodeRollNo.examCodeRollNoDtos.map(
                            (record, index) =>
                              index <
                              getExamCodeRollNo.examCodeRollNoDtos.length /
                              2 && (
                                <tr key={record.serialeNo}>
                                  <td className="text-center">{record.serialeNo}</td>
                                  <td className="text-center">{record.rollNo}</td>
                                  {record.code.map((subject, index) => (
                                    <React.Fragment key={index}>
                                      <td>{subject.codeNo}</td>
                                    </React.Fragment>
                                  ))}
                                </tr>
                              )
                          )}
                        </tbody>
                      </table>
                    </div>
                    <div className="w-50">
                      <table className="table text-center">
                        <thead className="thead-light">
                          <tr>
                            <th className="text-center">Sr. No.</th>
                            <th className="text-center">Roll No</th>
                            {getExamCodeRollNo.examCodeRollNoDtos[0]?.code.map(
                              (subject, index) => (
                                <React.Fragment key={index}>
                                  <th>{subject.subjectName}</th>
                                </React.Fragment>
                              )
                            )}
                          </tr>
                        </thead>
                        <tbody>
                          {getExamCodeRollNo.examCodeRollNoDtos.map(
                            (record, index) =>
                              index >=
                              getExamCodeRollNo.examCodeRollNoDtos.length /
                              2 && (
                                <tr key={record.serialeNo}>
                                  <td className="text-center">{record.serialeNo}</td>
                                  <td className="text-center">{record.rollNo}</td>
                                  {record.code.map((subject, index) => (
                                    <React.Fragment key={index}>
                                      <td>{subject.codeNo}</td>
                                    </React.Fragment>
                                  ))}
                                </tr>
                              )
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              )}
          </div>

          {approvalEntityModal && (
            <ExMD_ApprovalEntity
              showModal={approvalEntityModal}
              setShowModal={setApprovalEntityModal}
              setSelectedApprovalEntity={selectedApprovalEntity}
            />
          )}

          {marksCriteriaApprovalEntityModal && (
            <ApprovalMarksCriteriaEntity
              showModal={marksCriteriaApprovalEntityModal}
              setShowModal={setMarksCriteriaApprovalEntityModal}
              setSelectedApprovalEntity={selectedMarksCriteriaApprovalEntity}
            />
          )}

          <ImportBarcodeCSV
            showImportBarcode={showImportBarcode}
            setShowImportBarcode={setShowImportBarcode}
            onCancelButton={onCancelButton}
          />
          <ImportMarkCSV
            showImportMarks={showImportMarks}
            setShowImportMarks={setShowImportMarks}
            onCancelButton={onCancelButton}
          />
        </div>
      </div>
    </div>
  );
};

export default ExaminersAndModeratorReport;
